import { ResumePetisSimulationProposalClientRequest } from '../../../@types/ResumePetisSimulationProposal'

export const useResumePetisSimulationProposalPayload = (requestId: string) => {
  const resumePetisSimulationProposalPayload: ResumePetisSimulationProposalClientRequest =
    {
      requestId: requestId, //TODO: Verify if its quote or proposal ID
    }

  return { resumePetisSimulationProposalPayload }
}
